import React from 'react';
import Stack from '../../components/StackSection/Stack';
import Me from '../../components/Me/Me';
import './inicio.scss';
import '../../index.css';
import ContactCard from '../../components/Contact/ContactCard';

const Inicio = () => {
    return(
        <div className="container">
             <Me />
             <Stack />
             <ContactCard />
        </div>
    )
}

export default Inicio